
const descendingComparatorString = (a: any, b: any, orderBy: string) => {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

const descendingComparatorDate = (a: any, b: any, orderBy: string) => {
  if (new Date(b[orderBy]) < new Date(a[orderBy])) return -1;
  if (new Date(b[orderBy]) > new Date(a[orderBy])) return 1;
  return 0;
}

export const getComparator = (
  order: "desc" | "asc",
  orderBy: string,
  typeOrder: "string" | "date"
) => {
  if (order === 'desc') {
    if (typeOrder === 'string') {
      return (a: any, b: any) => descendingComparatorString(a, b, orderBy)
    } else {
      return (a: any, b: any) => descendingComparatorDate(a, b, orderBy)
    }
  } else {
    if (typeOrder === 'string') {
      return (a: any, b: any) => -descendingComparatorString(a, b, orderBy)
    } else {
      return (a: any, b: any) => -descendingComparatorDate(a, b, orderBy)
    }
  }
}

export const sortList = (
  array: any,
  comparator: (a: any, b: any) => number
) => {
  let stabilizedThis = array.map((el: any, index: number) => ({
    el,
    index,
  }));
  stabilizedThis = stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a.el, b.el);
    if (order !== 0) return order;
    return a.index - b.index;
  })

  return stabilizedThis.map((element: any) => element.el);
}
